<template>
  <div class="messages-list">
    <transition name="slide-top-down" mode="out-in">
      <div :key="page">
        <div
          class="messages-list__item card"
          v-for="message in messages"
          :key="message.id"
          :class="{
            'messages-list__item--read': message.read && !isCurrent(message.id),
            'messages-list__item--active': isCurrent(message.id)
          }"
          @click="$emit('click-message', message)"
        >
          <div class="messages-list__item__header card-header">
            <p
              class="messages-list__item__header__date card-header-title is-unselectable"
            >
              {{ formatDate(message.date) }}
            </p>
            <p
              class="messages-list__item__header__icon card-header-icon"
              :class="{
                'messages-list__item__header__icon--new': !message.read
              }"
            >
              <icon name="fa-circle" />
            </p>
          </div>
          <div class="card-content messages-list__item__title is-unselectable">
            {{ message.title }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { prettyDate } from "%utils/date";

import { Icon } from "%helpers";

export default {
  name: "messages-list",

  props: {
    messages: Array,
    current: Object,
    page: Number,
    pageable: Object
  },

  components: {
    Icon
  },

  methods: {
    formatDate(date) {
      return date ? prettyDate(date) : "";
    },

    isCurrent(id) {
      return this.current && this.current.id === id;
    }
  }
};
</script>

<style lang="scss" scoped>
$animation-duration: 0.3s;

.messages-list {
  &__item {
    margin-bottom: 1rem;
    cursor: pointer;
    transform: translateX(0);
    opacity: 0.9;
    min-height: 9rem;
    transition: $animation-duration;
    position: relative;

    &__header {
      overflow: hidden;
      padding: {
        left: 2rem;
        right: 2rem;
      }

      &__date {
        font-size: 0.8rem;
        font-weight: 400;
        padding: {
          left: 0;
          right: 0;
        }
      }

      &__icon {
        transform: translateX(150%);
        transition: $animation-duration;
        color: $info;
        opacity: 0;

        &--new {
          transform: translateX(0);
          transition: $animation-duration;
          opacity: 1;
        }
      }
    }

    &__title {
      font-weight: 600;
      font-family: $family-sans-serif-condensed;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: {
        left: 2rem;
        right: 2rem;
      }
    }

    &:hover {
      opacity: 1;
      transition: $animation-duration;
    }

    &--active {
      transition: $animation-duration;
      opacity: 1;
    }

    &:before {
      position: absolute;
      display: block;
      content: "";
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border-left: solid 1rem $primary2;
      transform: scaleX(0);
      transform-origin: 0;
      transition: transform 250ms ease-in-out;
      margin: 0;
    }

    &--active:before {
      transform: scaleX(1);
    }

    &--read {
      opacity: 0.4;
      transition: $animation-duration;
    }

    &--read:hover {
      opacity: 0.6;
      transition: $animation-duration;
    }
  }
}
</style>
